'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compareVersions = require('compare-versions');

var _compareVersions2 = _interopRequireDefault(_compareVersions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUnsupportedBrowser(currentBrowser, excludedBrowsers) {
  return excludedBrowsers.some(function (excludedBrowser) {
    var isRestrictedBrowser = excludedBrowser.name.toLowerCase() === currentBrowser.name;
    var isUnsupportedVersion = !excludedBrowser.version || (0, _compareVersions2.default)(currentBrowser.version, excludedBrowser.version) === -1;
    return isRestrictedBrowser && isUnsupportedVersion;
  });
}

exports.default = isUnsupportedBrowser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-exclude-browser/build/util/isUnsupportedBrowser.js
// module id = 66
// module chunks = 0